export default {
  name: 'Page404',
  computed: {}
};